var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "material-card",
    _vm._b(
      {
        staticClass: "v-card--material-stats",
        scopedSlots: _vm._u([
          {
            key: "offset",
            fn: function () {
              return [
                _c(
                  "v-card",
                  {
                    staticClass: "pa-4",
                    class: `elevation-${_vm.elevation}`,
                    attrs: { color: _vm.color, dark: "" },
                  },
                  [
                    _c("v-icon", { attrs: { size: "40" } }, [
                      _vm._v("\n        " + _vm._s(_vm.icon) + "\n      "),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mx-2",
                    attrs: { color: _vm.subIconColor, size: "20" },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.subIcon) + "\n    ")]
                ),
                _vm._v(" "),
                _c("span", {
                  staticClass: "caption font-weight-light",
                  class: _vm.subTextColor,
                  domProps: { textContent: _vm._s(_vm.subText) },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "material-card",
      { ..._vm.$attrs },
      false
    ),
    [
      _vm._v(" "),
      _c("div", { staticClass: "text-right" }, [
        _c("p", {
          staticClass: "body-2 grey--text font-weight-light mb-0",
          domProps: { textContent: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _c("h3", { staticClass: "headline font-weight-light text--primary" }, [
          _vm._v("\n      " + _vm._s(_vm.value) + "\n      "),
          _c("small", [_vm._v(_vm._s(_vm.smallValue))]),
        ]),
      ]),
      _vm._v(" "),
      _c("v-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }